import { Injectable } from "@angular/core";
import { AssessmentService } from "./assessment.service";
import { Observable } from "rxjs";
import { MaturityAssessment } from "./assessment.types";
import { ActivatedRouteSnapshot } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class AdminAssessmentResolver {
  constructor(private assessmentService: AssessmentService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<MaturityAssessment | null> {
    return this.assessmentService.getMaturityAssessmentStateById(route.params["id"]);
  }
}
